import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";

const DashboardCalendar = () => {
  const [webinar, setWebinar] = useState([]);
  const [fetchWebinarRecord, setFetchWebinarRecord] = useState(true);
  const now = new Date();
  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");

  const centralizeData = (response) => {
    return response?.map((el) => ({
      start: moment(el.webinarDate).format("YYYY-MM-DD"),
      title: el.eventName,
      id: el.id,
      eventEndTime: el.endTime,
      eventStartTime: el.startTime,
      endDate: el.endDate,
    }));
  };

  useEffect(() => {
    const fetchWebinars = async () => {
      try {
        const response = await axiosInstance.get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`);
        setWebinar(centralizeData(response.data.data));
      } catch (err) {
        console.error("Error fetching webinars:", err);
      } finally {
        setFetchWebinarRecord(false);
      }
    };

    fetchWebinars();
  }, []);


  return (
    <>
      {webinar && webinar.length !== 0 && (
        <>
          <p className="paragraph-css pb-15">Event Calender</p>
          <div className="fullcalendraDashboard">
            {fetchWebinarRecord ? (
              <div className="admindata-loading">
                <Loading />
              </div>
            ) : (
              <FullCalendar
                schedulerLicenseKey={"GPL-My-Project-Is-Open-Source"}
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin,
                  resourceTimelinePlugin,
                ]}
                headerToolbar={{
                  left: "prev",
                  center: "title",
                  right: "next",
                }}
                editable={true}
                eventBackgroundColor="#F4E6FD"
                selectable={true}
                selectHelper={true}
                events={webinar}
                selectMirror={true}
                dayMaxEvents={true}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DashboardCalendar;
